import { Route } from 'config/routes';

export const ROUTE_TO_PAGE_TYPE: Record<Route, string> = {
  [Route.AddressPage]: 'address_page',
  [Route.UnitPage]: 'unit_page',
  [Route.UnitPageCommercial]: 'unit_page',
  [Route.Home]: 'home_page',
  [Route.Search]: 'search_result_page',
  [Route.TermsPage]: 'terms_page',
  [Route.Profile]: 'profile_page',
  [Route.ProjectPage]: 'project_page',
  [Route.ProjectPageCommercial]: 'project_page',
  [Route.ProjectPromotionPage]: 'project_promotion_page',
  [Route.CheckAddress]: 'check_address_page',
  [Route.MyHomes]: 'my_homes_page',
  [Route.SavedSearchesPage]: 'saved_searches_page',
  [Route.Shortlist]: 'favorites_page',
  [Route.LocalPage]: 'local_page',
  [Route.UnsubscribePage]: 'unsubscribe_page',
  [Route.SavedSearch]: 'saved_search_redirect_page',
  [Route.AriaSearchForm]: 'aria_search_form_page',
  [Route.AriaSearchResults]: 'aria_search_results_page',
  [Route.AriaUnit]: 'aria_unit_page',
  [Route.AriaProject]: 'aria_project_page',
  [Route.UploadBulletin]: 'upload_bulletin_page',
  [Route.ManageBulletins]: 'manage_bulletins_page',
  [Route.EditBulletin]: 'edit_bulletin_page',
  [Route.EditCommercialBulletin]: 'edit_bulletin_page',
  [Route.Sold]: 'sold_page',
  [Route.StreetPage]: 'street_page',
  [Route.MadadPage]: 'madad_landing_page',
  [Route.MadadCity]: 'madad_area_page',
  [Route.MadadArchivePage]: 'madad_page',
  [Route.MadadCityArchive]: 'madad_page',
  [Route.MadadArchive2020Page]: 'madad_page',
  [Route.MadadAgentPage]: 'madad_page',
  [Route.MadadSearchPage]: 'madad_search_page',
  [Route.Accessibility]: 'accessibility_page',
  [Route.Sitemap]: 'sitemap_page',
  [Route.CommercialMarketLanding]: 'commercial_landing',
  [Route.SearchCommercial]: 'search_result_page',
  [Route.DeveloperPage]: 'developer_page',
  [Route.DevelopersSearchPage]: 'developer_index',
  [Route.DevelopersCitySearchPage]: 'developer_index',
  [Route.MortgageOfficesSearchPage]: 'mortgage_index_page',
  [Route.MortgageOfficesCitySearchPage]: 'mortgage_index_page',
  [Route.EmploymentAreaPage]: 'employment_area_page',
  [Route.MortgageOfficePage]: 'mortgage_consult_page',
  [Route.OfficePage]: 'office_page',
  [Route.AgentPage]: 'agent_page',
  [Route.MadadLottery]: 'lottery_page',
  [Route.MadadLotteryTerms]: 'lottery_terms_page',
  [Route.Israel4ever]: 'host_refugees',
  [Route.AutomationTestPage]: 'sitemap_page', // test page for automation, value is just for not to fail
  [Route.PushSettings]: 'notification_manager_page',
  [Route.DevelopersPromotionPage]: 'b2b_landing_page',
  [Route.AgentsPromotionPage]: 'b2b_landing_page',
  [Route.Deals]: 'console_agent_deals_page',
  [Route.MyDeals]: 'console_agent_my_deals_page',
  [Route.Listings]: 'console_agent_listings_page',
  [Route.UploadBulletinForm]: 'console_agent_upload_bulletin_form_page',
  [Route.EditBulletinForm]: 'console_agent_edit_bulletin_form_page',
  [Route.EditResidentialBulletinForm]: 'console_agent_edit_bulletin_form_page',
  [Route.OfficeProfilePage]: 'console_agent_office_profile_page',
  [Route.OfficeStaffPage]: 'console_agent_office_staff_page',
  [Route.CreateOfficeAgent]: 'console_agent_create_office_agent_page',
  [Route.EditOfficeAgent]: 'console_agent_edit_office_agent_page',
  [Route.AgentConsoleHomePage]: 'console_agent_home_page',
  [Route.School]: 'school_page',
  [Route.AgentSharePage]: 'agent_share_page',
  [Route.InvestorsHomePage]: 'investors_home_page',
  [Route.InvestorsProfilePage]: 'investors_profile_page',
  [Route.InvestorsFavoriteNeighourhoodPage]: 'investors_favorite_neighbourhood_page',
  [Route.InvestorsLobbyPage]: 'investors_lobby_page',
  [Route.InvestorsLoginPage]: 'investors_login_page',
  [Route.InvestorsNeighbourhoodPage]: 'investors_neighbourhood_page',
  [Route.InvestorsWizardPage]: 'investors_wizard_page',
  [Route.InvestorsSearchPage]: 'investors_search_page',
  [Route.EducationCityPage]: 'education_city_page',
  [Route.Playground]: 'playground',
};
